export const MYM_WEB = 'mym'
export const CA_WEB = 'ca'
export const LA_WEB = 'la'
export const PERIODICALS_WEB = 'periodicals'
export const EDUCATION_WEB = 'education'
export const M_TAG_MANAGER_WEB = 'm-tag-manager'
export const CLIENT_PORTAL = 'client-portal'


// WEBPACK FOOTER //
// ./src/utils/constants/rbuConstants.js